module.exports = __webpack_public_path__ + "img/banner_1.a843e9b1.webp";